// This file is generated by a script. Do not edit this file directly.
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Doc = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Doc = void 0;
  _react = _interopRequireWildcard(_react);
  var React = _react;
  function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
  function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Doc = _exports.Doc = function Doc(props) {
    return /*#__PURE__*/React.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "currentColor",
      strokeLinejoin: "round",
      strokeWidth: 1.5,
      d: "M16.927 8.496v8.43a2.08 2.08 0 0 1-2.078 2.079H5.152a2.08 2.08 0 0 1-2.078-2.078V3.074A2.08 2.08 0 0 1 5.152.996h4.275c.367 0 .72.146.98.406l6.114 6.115c.26.26.406.612.406.98Z"
    }), /*#__PURE__*/React.createElement("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.5,
      d: "M10 1.342v5.195a1.385 1.385 0 0 0 1.385 1.385h5.195"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "currentColor",
      d: "M6.094 15.686c1.108 0 1.795-.684 1.795-1.82 0-1.134-.687-1.816-1.797-1.816H4.75v3.636zm-.465-.75V12.8h.419c.625 0 .96.284.96 1.067 0 .787-.335 1.07-.948 1.07zM11.835 13.868c0-1.202-.76-1.868-1.737-1.868-.98 0-1.735.666-1.735 1.868 0 1.197.755 1.868 1.735 1.868.977 0 1.736-.666 1.736-1.868m-.899 0c0 .712-.312 1.097-.838 1.097-.524 0-.838-.385-.838-1.097s.314-1.097.838-1.097c.526 0 .838.385.838 1.097M15.648 13.367c-.088-.87-.736-1.367-1.615-1.367-.97 0-1.724.666-1.724 1.868 0 1.197.737 1.868 1.724 1.868.998 0 1.55-.679 1.615-1.323l-.887-.005c-.062.35-.325.557-.71.557-.519 0-.846-.374-.846-1.097 0-.694.32-1.097.85-1.097.4 0 .661.232.706.596z"
    }));
  };
});
